<h1 mat-dialog-title>Your ad was submitted successfully!</h1>
<div mat-dialog-content>
  <p>{{ confirmationNumMsg }}</p>
  <p>
    Please contact
    <!-- <a href="mailto:support@orcatv.com" target="_blank">support@orcatv.com</a> prod -->
    <a href="mailto:ces-content@apogee.us" target="_blank">ces-content@apogee.us</a> 
     if this
    information changes or is incorrect.
  </p>
  <p>Thank you for your submission!</p>
</div>
<div mat-dialog-actions fxLayout="column" fxLayoutGap="15px">
  <button mat-raised-button mat-dialog-close class="primary">
    <mat-icon>publish</mat-icon>
    Keep Form Data and Submit Again!
  </button>
  <button mat-stroked-button [mat-dialog-close]="true">
    <mat-icon>refresh</mat-icon>
    Reset Form and Submit Again!
  </button>
</div>
